import { CHAT_MESSAGE_CLOUD_HIGHLIGHT_CLASS } from '@/shared/ui/Chat';

/** Длительность анимации подсветки — парная с `chatCloudHighlight` в `ChatMessageCloud.module.css` */
const HIGHLIGHT_DURATION_MS = 2300;

/** Таймеры снятия подсветки по облакам: повторный переход к ещё подсвеченному облаку её не перезапускает */
const highlightTimers = new WeakMap<HTMLElement, ReturnType<typeof setTimeout>>();

/**
 * На время выделяет облако переписки контрастным цветом: найденную реплику звонка и найденное сообщение
 * текстовой коммуникации — одинаково.
 */
export const highlightCloud = (element: HTMLElement): void => {
  if (highlightTimers.has(element)) return;

  element.classList.add(CHAT_MESSAGE_CLOUD_HIGHLIGHT_CLASS);
  const timer = setTimeout(() => {
    element.classList.remove(CHAT_MESSAGE_CLOUD_HIGHLIGHT_CLASS);
    highlightTimers.delete(element);
  }, HIGHLIGHT_DURATION_MS);
  highlightTimers.set(element, timer);
};
